module.exports = __webpack_public_path__ + "static/media/step3.1f86b9d4.png";